var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.394 21.178l3.048 3.049 2.357-2.359-3.049-3.046 2.359-2.357 3.046 3.047 2.357-2.357-3.045-3.048 2.357-2.357 3.046 3.048 2.358-2.358-3.048-3.047 4.715-4.713a1.667 1.667 0 012.357 0l7.072 7.07a1.667 1.667 0 010 2.357L14.109 35.32a1.667 1.667 0 01-2.359 0l-7.07-7.07a1.667 1.667 0 010-2.357l4.714-4.715zm14.141 9.427l7.072-7.07L35 27.927V35h-7.07l-4.395-4.395zM9.394 16.463L4.68 11.75a1.667 1.667 0 010-2.358l4.714-4.714a1.667 1.667 0 012.356 0l4.717 4.714-7.073 7.071z",
    fill: "#DFE2E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.f67a753fa4c828edc5c3572e62f0b1e5.svg";
export { ForwardRef as ReactComponent };